import { ApiGenericResponse } from "../ApiGenericResponse";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { UpdateCurrentUserReqData } from "./UpdateCurrentUserReqData";

const ENDPOINT = "/auth/current";

export class UpdateCurrentUserCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: UpdateCurrentUserReqData;

    constructor(payload: UpdateCurrentUserReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand(this.payload);
        return new ApiGenericResponse(res);
    }
}
